import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCHE7cwqwardKbvHewh70RUcd_XK2S0msA",
  authDomain: "uiawebsite.firebaseapp.com",
  databaseURL: "https://uiawebsite-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "uiawebsite",
  storageBucket: "uiawebsite.firebasestorage.app",
  messagingSenderId: "439116912285",
  appId: "1:439116912285:web:888e8fda0f833f4390e674",
  measurementId: "G-7JGYMG0JBN"
};

const app = initializeApp(firebaseConfig);
export const db = getDatabase(app);
export const auth = getAuth(app);
export default app;
